<script lang="ts" setup>
import { Button } from '@brighterly/lib-lumee-ui'

import { AppModal } from '@shared/ui/modals'

import { useLessonRoomStore } from '../../model/store'

defineOptions({
  name: 'LessonRoomAlternativeVoip',
})

const lessonRoomStore = useLessonRoomStore()

const zoomLink = computed<string | null>(() => lessonRoomStore.getBooking?.tutor?.zoom_link ?? null)

const handleRedirect = (): void => {
  if (zoomLink.value) {
    window.open(zoomLink.value, '_blank')
  }
}

onMounted(() => {
  if (!zoomLink.value) {
    console.warn('missing tutor zoom_link for LessonRoomAlternativeVoip')
  }
})
</script>

<template>
  <AppModal :show-button-close="false">
    <template #contentSlot>
      <div class="lesson-room-alternative-voip">
        <p class="lesson-room-alternative-voip__title btly-text-title-s">
          Continue your lesson
        </p>
        <p class="lesson-room-alternative-voip__description btly-text-title-s">
          You’ve faced tech issues, so we made another room in Zoom. Join it by clicking the button below.
        </p>
      </div>
    </template>
    <template #bottomSlot>
      <Button
        text="Start lesson in Zoom"
        fill
        :disabled="!zoomLink"
        @click="handleRedirect"
      />
    </template>
  </AppModal>
</template>

<style scoped lang="scss" src="./LessonRoomAlternativeVoip.scss" />
